<template>
  <div>
    <div id="surveyPreview" v-if="isPreviewMode">
      <v-app-bar
          outlined
          flat
          color="white"
          height="52px"
          style="border-bottom: 1px solid #EDEDED !important;"
      >
        <IconTooltipButtonBottom
            icon="mdi-arrow-left"
            tooltip="Zurück zur Liste"
            id="default"
            width="50px"
            large
            @click="resetPreviewMode()"
        />
        <v-toolbar-title>{{selectedSchema.title}}</v-toolbar-title>
        <div>
          <v-btn elevation="0" color="primary"
                 @click="sendSurvey(selectedItem.id)">Umfrage senden</v-btn>
        </div>
      </v-app-bar>
      <v-card flat class="px-layout max-height">
        <PXSurvey :schema="selectedSchema" :displayMode="'display'" class="px-survey-preview pa-10"/>
      </v-card>
    </div>
    <div id="mainFrame" v-else-if="!isPreviewMode">
      <v-row align="center">
        <v-col>
          <h1>Umfragen</h1>
        </v-col>
        <v-col class="text-right">
          <v-btn color="primary" medium elevation="0" @click="addSurvey()">
            <v-icon color="#F5F5F5" medium>add</v-icon > Neue Umfrage
          </v-btn>
        </v-col>
      </v-row>
      <v-main style="margin:5px; padding: 0;" v-if="!isPreviewMode" id="surveyOverview">
        <v-data-table
            dense
            :headers="headers"
            :items="questions"
            :items-per-page="15"
            sort-by="createdDate"
            :sort-desc="true"
        >
          <template v-slot:body="{items}">
            <tbody>
            <tr v-for="item in items"
                :key="item.id"
                @mouseover="selectItem(item)"
                @mouseleave="unSelectItem(item)">
              <td>
                <a @click="previewSurvey(item)">
                  {{ item.title }} 
                </a>
              </td>
              <td>
                  <v-chip v-if="item.module !== 'NONE' " small outlined color="gray_3" text-color="gray"
                          class="module-tag">{{decodeModuleNameByEnum(item.module)
                    }}</v-chip>
                  <span v-else class="text-description text-gray">{{decodeModuleNameByEnum(item.module)}}</span>
              </td>
              <td>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span class="date cursor-default" color="gray_3" v-bind="attrs" v-on="on" style="vertical-align: center;">{{
                        new Date(item.createdDate).toLocaleString('de-DE', {day: 'numeric', month: 'short', year: 'numeric'}) }}</span>
                  </template>
                  <span>{{ new Date(item.createdDate).toLocaleString('de-DE') }}</span>
                </v-tooltip>
              </td>
              <td style="max-width:80px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; text-align:center;">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span class="cursor-default" v-bind="attrs" v-on="on">
                      {{fetchAvatar(item.createdBy)}}
                      <v-avatar
                          :color="item.iconColor"
                          size="32"
                          style="color: #fff;"
                      >{{initials(item.createdBy)}}
                        {{item.initial}}
                      </v-avatar>
                    </span>
                  </template>
                  <span>{{ item.createdBy }}</span>
                </v-tooltip>
              </td>
              <td>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }" style="text-align: start">
                    <span class="date cursor-default" color="gray_3" v-bind="attrs" v-on="on" style="vertical-align: center;">{{ item.deadlineDate == null ? "-" : new Date(item.deadlineDate).toLocaleString('de-DE', { day: 'numeric', month: 'short', year: 'numeric'}) }}</span>
                  </template>
                  <span>
                    {{ item.deadlineDate == null ? "Es gibt keine Deadline" : new
                  Date(item.deadlineDate).toLocaleString('de-DE') }}
                  </span>
                </v-tooltip>
              </td>
              <td>
                <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-badge
                        :value="item.info.evaluationTimestampCount"
                        :content="item.info.evaluationTimestampCount"
                        :color="parseSurveyStateColor(item.info.state)"
                        class="timestamp-count-badge"
                    >
                      <v-chip label small :color="parseSurveyStateColor(item.info.state)+'_s'"
                              :text-color="parseSurveyStateColor(item.info.state)"
                              class="mr-2">
                        {{ decodeSurveyState(item.info.state) }}
                      </v-chip>
                    </v-badge>
<!--                    <v-chip class="timestamp-count font-weight-bold" small v-if="item.info.evaluationTimestampCount !=0"-->
<!--                             :color="parseSurveyStateColor(item.info.state)"-->
<!--                            text-color="white">{{-->
<!--                        item.info.evaluationTimestampCount-->
<!--                      }}</v-chip>-->
                  </span>
                </template>
                <span>
                  {{ getSurveyStateDescription(item.info.state) }}
                  <br> Wiederholt verschickt: {{ item.info.evaluationTimestampCount }}
                </span>
              </v-tooltip>

                
              </td>
              <td style="max-width: 80px; font-weight: 700;"
                  class="text-gray text-center cursor-default">
                <span class="d-block text-spotted">{{ item.info.sendToCount}}</span>
                <span class="d-block text-subtitle">Mitarbeitende</span>
              </td>
              <td style="max-width: 80px; font-weight: 700;" class="text-gray text-center cursor-default">
                <span class="d-block text-spotted">{{ item.info.answeredCount}}</span>
                <span class="d-block text-subtitle">Mitarbeitende</span>
              </td>
              <td>
                    <v-tooltip v-if="item.modelUuid != null && item.module == 'Module_Four'" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span
                          v-bind="attrs"
                          v-on="on"
                        >
                        <v-btn :disabled="(item.info.answeredCount == 0)" color="gray" @click="openProcessModelEvaluation(item)" small text class="btn__evaluation">
                          <v-icon>mdi-open-in-new</v-icon>
                          Auswertung
                        </v-btn>
                      </span>
                      </template>
                      <span>Diese Umfrage enthält Prozessbezug und kann deshalb nur am Prozessmodell ausgewertet werden</span>
                    </v-tooltip>
                    <v-tooltip v-else-if="item.module != 'NONE' && (item.info.answeredCount == 0 || creatingEvaluationTimestamp)" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span
                          v-bind="attrs"
                          v-on="on"
                        >
                        <v-btn :disabled="creatingEvaluationTimestamp || item.info.evaluationTimestampCount == 0"
                               color="gray" small text @click="evaluateSurvey(item)" class="btn__evaluation">
                          <v-icon>mdi-chart-timeline-variant</v-icon>
                          &nbsp;Auswertung
                        </v-btn>
                      </span>
                      </template>
                      <span v-if="creatingEvaluationTimestamp && creatingTimestampForId == item.id">Ein Auswertungspunkt wird gerade erstellt...</span>
                      <span v-if="item.info.answeredCount == 0 && item.info.evaluationTimestampCount < 1">Es sind noch keine Antworten vorhanden</span>
                      <span v-else>Auswertung</span>
                    </v-tooltip>
                    <v-tooltip v-else bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span
                            v-bind="attrs"
                            v-on="on"
                        >
                          <v-btn color="gray" text small @click="evaluateSurvey(item)"  class="btn__evaluation">
                              <v-icon>mdi-chart-timeline-variant</v-icon>
                              &nbsp;Auswertung
                          </v-btn>
                        </span>
                      </template>
                      <span>Antworten zu Ihrer Umfrage sind vorhanden</span>
                    </v-tooltip>
              </td>
              <td>
                <div v-if="item === selectedItem" class="d-inline btn-group">
                  <v-tooltip v-if="item.info.answeredCount == 0" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="gray" small text @click="sendSurvey(item.id)" v-bind="attrs" v-on="on"
                             class="btn-group__btn"><v-icon>send</v-icon> </v-btn>
                    </template>
                    <span>Versenden</span>
                  </v-tooltip>
                  <v-tooltip v-if="item.module != 'NONE' && item.info.sendToCount > 0 && item.module != 'Module_Four' && item.info.answeredCount > 0" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="gray" small text @click="resendSurvey(item)" v-bind="attrs" v-on="on"
                             class="btn-group__btn"><v-icon>mdi-file-send-outline</v-icon> </v-btn>
                    </template>
                    <span>Umfrage erneut starten</span>
                  </v-tooltip>
                  <v-tooltip v-if="item.modelUuid != null && item.module == 'Module_Four'" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="gray" small text @click="openProcessModel(item.modelUuid)" v-bind="attrs" v-on="on"
                             class="btn-group__btn"><v-icon>mdi-open-in-new</v-icon> </v-btn>
                    </template>
                    <span>Prozessmodell öffnen</span>
                  </v-tooltip>
                  <v-tooltip v-if="item.module == 'NONE'" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="gray" small text @click="copySurvey(item)" v-bind="attrs" v-on="on"
                      class="btn-group__btn"><v-icon>mdi-content-copy</v-icon></v-btn>
                    </template>
                    <span>Kopieren</span>
                  </v-tooltip>
                  <v-tooltip v-if="item.info.state == 'ANSWERED'" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn :disabled="item.info.state != 'ANSWERED'" color="gray" small text @click="createEvaluation(item.id)" v-bind="attrs" v-on="on"
                             class="btn-group__btn"><v-icon>mdi-cancel</v-icon></v-btn>
                    </template>
                    <span>Umfrage beenden</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="gray" small text @click="deleteSurvey(item.id)" v-bind="attrs" v-on="on"
                      class="btn-group__btn"><v-icon>delete</v-icon></v-btn>
                    </template>
                    <span>Löschen</span>
                  </v-tooltip>
                </div>
              </td>
            </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-main>
    </div>
    <SurveySendDialog ref="sendSurvey" :surveyId="selectedSurveyId" @showSnackbar="showSnackbar($event)"/>
    <SurveyGenerationModePicker ref="modePicker"/>
    
    <v-snackbar
        timeout="-1"
        v-model="snackbar"
    >
      {{ snackbarText }}
    </v-snackbar>
    <ConfirmDialog ref="confirmDialog" />
    <PickCopySurveyName ref="formDialog" />
  </div>
</template>

<script>
import pxSurveyService from './px-survey-service'
import userService from '@/components/userService'
import PXSurvey from "@/components/common/PXSurvey.vue"
import IconTooltipButtonBottom from "@/components/common/IconTooltipButtonBottom.vue"
import SurveySendDialog from './SurveySendDialog.vue';
import SurveyGenerationModePicker from './SurveyGenerationModePicker.vue';
import ConfirmDialog from '@/components/common/ConfirmDialog.vue';
import AddSurveyTextDialog from '@/components/common/AddSurveyTextDialog.vue';
import PickCopySurveyName from './PickCopySurveyName.vue';

import {decodeModuleNameByEnum, decodeSurveyState, parseSurveyStateColor, getSurveyStateDescription} from "@/components/util.js"
export default {
  components: {
    PXSurvey,
    SurveySendDialog,
    SurveyGenerationModePicker,
    ConfirmDialog,
    AddSurveyTextDialog,
    PickCopySurveyName,
    IconTooltipButtonBottom
},
  data: () => ({
    questions: [],
    headers: [
        { text: 'Titel der Umfrage', value: 'title' },
        { text: 'Modul', value: 'module' },
        { text: 'Erstellt am', value: 'createdDate', dataType: "Date" },
        { text: 'Erstellt von', value: 'createdBy'},
        { text: 'Deadline', value: 'deadlineDate', dataType: "Date" },
        { text: 'Status', value: 'info.state', sortable: false },
        { text: 'Versendet an', value: 'info.sendToCount', sortable: false },
        { text: 'Beantwortet von', value: 'info.answeredCount', sortable: false },
        { text: 'Auswertung', value: 'surveyResult'},
        { text: '', value: 'actions', sortable: false }
        
      ],
    isPreviewMode: false,
    selectedSchema: [],
    showSurveySendDialog: false,
    selectedSurveyId: null,
    selectedItem: false,
    snackbar: false,
    snackbarText: 'Umfrage wurde erfolgreich versendet!',
    appBarLeft: null,
    creatingEvaluationTimestamp: false,
    creatingTimestampForId: null
  }),
  props: {
  },
  computed: {
  },
  watch: {
  },
  mounted() {
    this.fetchSurveys();
  },
  methods: {
    decodeSurveyState:decodeSurveyState,
    decodeModuleNameByEnum: decodeModuleNameByEnum,
    getSurveyStateDescription: getSurveyStateDescription,
    parseSurveyStateColor: parseSurveyStateColor,
    checkForNewSurvey(item){
      const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      const firstDate = new Date(item.createdDate);
      const secondDate = new Date();

      const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));
      return diffDays <= 7 ? true : false;
    },
    addSurvey(){
      this.$refs.modePicker
          .open()
          .then((mode) => this.$router.push({name: 'createSurvey', params: {mode: mode}}));
    },
    evaluateSurvey(item){
      if(item.module == "NONE"){
        this.$router.push({name: 'evaluateCustomSurvey', params: { surveyId: item.id }});
      }else{
        this.$router.push({name: 'evaluateSurvey', params: { surveyId: item.id }});
      }
      //
    },
    fetchSurveys(){
      pxSurveyService.retrievePXSurveys().then((res) => {
        this.questions = res.data;
      })
    },
    previewSurvey(survey){
      this.selectedSchema = JSON.parse(survey.schema);
      this.isPreviewMode = true;
    },
    resetPreviewMode(){
      this.selectedSchema = [];
      this.isPreviewMode = false;
    },
    sendSurvey(id){
      this.selectedSurveyId = id;
      this.$refs.sendSurvey
          .open()
          .then(() => {
            this.fetchSurveys();
            this.snackbar = true;
            this.snackbarText = 'Umfrage wurde erfolgreich versendet!';
            setTimeout(()=> {
              this.snackbar = false;
            }, 2000)
          });
      
    },
    selectItem(item) {
      this.selectedItem = item;
    },
    unSelectItem(item) {
      this.selectedItem = false;
    },
    showSnackbar(changedProp) {
      this.snackbar = changedProp;
    },
    deleteSurvey(id){
      this.$refs.confirmDialog
        .open(
          "Umfrage löschen",
          "Wenn Sie eine Umfrage löschen werden alle zugehörigen Daten (Auswertungen, Versendete Umfrage etc.) gelöscht. Sind Sie sich sicher?"
        )
        .then(() => {
          pxSurveyService.deleteSurvey(id).then(res => {
            this.fetchSurveys();
            this.snackbar = true;
            this.snackbarText = 'Umfrage wurde gelöscht';
            setTimeout(()=> {
              this.snackbar = false;
            }, 2000)
          });
        });
    },
    copySurvey(item){
      this.$refs.formDialog
        .open(
        "Hier können Sie den Namen der kopierten Umfrage anpassen:", (item.title+" (copy)")
        )
        .then((title) => {
            let copySchema = JSON.parse(item.schema);
            copySchema.title = title;
            pxSurveyService.savePXSurvey(copySchema, item.module).then(res => {
              this.fetchSurveys();
              this.snackbar = true;
              this.snackbarText = 'Umfrage wurde erfolgreich kopiert!';
              setTimeout(()=> {
                this.snackbar = false;
              }, 2000)
            });
        });

    },
    createEvaluation(surveyId){
      this.creatingTimestampForId = surveyId;
      this.creatingEvaluationTimestamp = true;
      this.snackbar = true;
      this.snackbarText = "Umfrage wird abgeschlossen...";
      pxSurveyService.finishSurvey(surveyId).then(()=> {
        this.creatingEvaluationTimestamp = false;
        this.snackbar = false;
        this.creatingTimestampForId = null;
        this.fetchSurveys();
      })
    },
    openProcessModel(uuid){
      let routeData = this.$router.resolve("/modelEdit/"+uuid);
      window.open(routeData.href, '_blank');
    },
    openProcessModelEvaluation(item){
      let routeData = this.$router.resolve({path:"/modelEdit/"+item.modelUuid, query: {mode: "px", surveyId: item.id}});
      let newWindow = window.open(routeData.href, '_blank');
      
    },
    initials(userId){
      /* userService.retrieveUser(userId).then((res) => {
        this.questions.forEach((elm) => {
          if(elm.createdBy === userId) elm.initial = res.data.firstName.substring(0,1).toUpperCase() +
              res.data.lastName.substring(0,1).toUpperCase();
        })
      }) */
      this.questions.forEach((elm) => {
          if(elm.createdBy === userId) elm.initial = userId.substring(0,2).toUpperCase();
        })
    },
    resendSurvey(item){
      localStorage.survey = JSON.stringify(item);
      this.$router.push({name: "resendSurvey", params: {
            survey: item,
            isResend: true
          }});
    },
    fetchAvatar(userId) {
      /* userService.retrieveUser(userId).then((res) => {
        this.questions.forEach((elm) => {
          if(elm.createdBy === userId) elm.iconColor = res.data.iconColor;
        })
      }) */

      this.questions.forEach((elm) => {
          if(elm.createdBy === userId) elm.iconColor = '#b2b2b2';
        })
    }
  },
};
</script>
<style lang="scss" scoped>
  .px-layout {
    overflow-y: scroll;
    height: 90vh;
    padding: 0 8vw;
  }
  .text-subtitle {
    //font-size: 1.2vmin;
    color: var(--gray-color_3);
    font-weight: 500;
  }
  .text-spotted {
    font-size: 0.9rem;
  }
  :deep th:nth-child(7), :deep th:nth-child(8) {
    max-width: 90px;
  }
  :deep th:nth-child(9) {
    max-width: 120px;
    padding-left: 30px !important;
  }
  :deep th {
    font-size: 1.2vmin !important;
    height: 60px !important;
    white-space: break-spaces;
    -ms-word-break: break-word;
    word-break: break-word;
    @media screen and (min-width: 2000px) {
      font-size: 12px !important;
    }
  }
  :deep td button.v-size--small {
    font-size: 1.3vmin;
    padding: 0;
    @media screen and (min-width:2000px){
      font-size: 12px;
    }
  }
  :deep td {
    padding: 0 10px !important;
  }
  :deep th {
    padding: 0 1vmin !important;
  }
  :deep td:nth-child(9) span {
    max-width: unset;
  }
  :deep td:last-child {
    min-width: 60px;
    width: 8vw;
  }
  :deep .px-survey-preview td:last-child {
    min-width: unset;
    width: unset;
  }
  :deep .px-survey-preview td {
    vertical-align: middle !important;
  }
  :deep .px-survey-preview .sv_q_m_label {
    position: unset;
  }
  :deep td:first-child {
    min-width: 200px;
    width: 24vw;
  }
  :deep td:last-child button.v-size--small {
    min-width: unset;
    width: 36px;
  }
  .btn__evaluation {
    padding: 1vmin 0.9vmin !important;
  }
  :deep .btn__evaluation .v-icon {
    font-size: 2.7vmin;

    @media screen and (min-width: 2000px) {
      font-size: 24px;
    }
  }
  .btn-group .btn-group__btn {
    padding: 0 !important;
    margin-right: 1px;
    max-width: 4vmin;
    height: 4vmin;
  }
  :deep .btn-group .v-btn .v-icon {
    font-size: 2.7vmin;
    letter-spacing: -1px;

    @media screen and (min-width: 2000px) {
      font-size: 28px;
    }
  }
  .timestamp-count {
    margin-left: -16px;
    opacity: .7;
    padding-left: 9px;
    padding-right: 9px;
  }
  :deep .v-badge__wrapper span {
    inset: auto auto calc(100% - 12px) calc(100% - 15px) !important;
    height: 16px;
    width: 16px;
    padding: 2px;
    min-width: unset;
    font-size: 10px;
    font-weight: 700;
    border: 1px solid #fff;
  }

  @media screen and (max-width: 1153px) {
    :deep tr td:first-child {
      font-size: 1.8vmin !important;
      min-width: unset;
      width: 25vw;
    }
    :deep tr td:last-child {
      width: 12vw;
      min-width: 110px;
    }
  }

</style>